import api from '@/api/index.js'

const top_up_stats = {
  state: {
    loading: false,
    data: null,
    error: null,
  },

  mutations: {
    SET_TOPUP_STATS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_TOPUP_STATS: (state, account) => {
      state.data = account
      state.loading = false
    },
    SET_TOPUP_STATS_ERROR: (state, error) => {
      state.error = error
      state.loading = false
    }
  },

  actions: {
    LoadTopUpSumsStats({commit}) {
      commit('SET_TOPUP_STATS_ERROR', null)
      commit('SET_TOPUP_STATS_LOADING', true)
      return api.get(`stats/top-ups`)
        .then((response) => {
          commit('SET_TOPUP_STATS', response)
        })
        .catch((error) => {
          commit('SET_TOPUP_STATS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  },
}

export default top_up_stats
